import { IconButton, Heading, Text, Button, HStack, VStack } from '@genial/components';
import { Spacing, Color, Typography } from '@genial/design-tokens';
import { useBreakpointValue } from '@genial/utils';
import { useNavigation } from '@react-navigation/native';
import React from 'react';

import { SignedInNavigationScreenNavigationProp } from '../../../../../../routes/types';

interface HeaderProps {}

export const Header: React.FC<HeaderProps> = () => {
  const { navigate } = useNavigation<SignedInNavigationScreenNavigationProp>();
  const isMobile = useBreakpointValue({ base: true, sm: false });

  const goToHistoryOrders = () => {
    navigate('OrdersHistory');
  };

  if (isMobile) {
    return (
      <VStack pt={Spacing['inline.xxs']} space={Spacing['inset.xs']}>
        <HStack alignItems="center" justifyContent={'space-between'}>
          <HStack alignItems="center" space={Spacing['inline.xxxs']}>
            <IconButton
              testId="icon"
              icon="ArrowLeft"
              iconSize="xxs"
              p={0}
              backgroundColor="transparent"
              iconColor={Color['brand.primary.principal']}
              onPress={goToHistoryOrders}
            />
            <Text variant="bold" fontSize={Typography['fontsize.lg']} color="neutral.black">
              Edição de Ordem
            </Text>
          </HStack>
          <Button
            variant="textLink"
            onPress={goToHistoryOrders}
            _text={{
              color: 'feedback.error.default',
              fontWeight: Typography['fontweight.semibold'],
            }}>
            Cancelar
          </Button>
        </HStack>
      </VStack>
    );
  }

  return (
    <HStack pt={Spacing['inset.lg']} alignItems="center" justifyContent="space-between">
      <HStack alignItems="center" space={Spacing['inline.xxxs']}>
        <IconButton
          icon="ArrowLeft"
          testId="return-button"
          shadow={3}
          variant="link"
          iconColor={Color['brand.tertiary.principal']}
          iconSize="xs"
          onPress={goToHistoryOrders}
        />
        <Heading testId="qa" size="h2">
          Edição de Ordem
        </Heading>
      </HStack>
    </HStack>
  );
};
